import { render, staticRenderFns } from "./dy-to-wx.vue?vue&type=template&id=4ec98c64&scoped=true&"
import script from "./dy-to-wx.vue?vue&type=script&lang=js&"
export * from "./dy-to-wx.vue?vue&type=script&lang=js&"
import style0 from "./dy-to-wx.vue?vue&type=style&index=0&id=4ec98c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec98c64",
  null
  
)

export default component.exports